<template>
  <div>
    <v-card class='ma-4' outlined>
      <v-card-title>
        Create/Delete Integrator in QxControl
      </v-card-title>
      <v-card-text>
        Use when <span style="font-weight: bold;">onboarding</span> a new Integrator or Distributor reseller 
        or when <span style="font-weight: bold;">provisioning</span> a new QXO systems. <br>
        Distributors are are only created in the Cloud.
      </v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-select 
              v-model="customerType"
              label="Customer Type"
              :items="customerTypes"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-checkbox 
              v-model="isCloud"
              label="Cloud (de-select for QXO)"
              :disabled="customerType == 'Distributor'"
            >
            </v-checkbox>
          </v-col>
           <v-col cols="12" sm="6" md="3">
            <v-text-field 
              v-model="serialNumber" 
              label="System Serial Number" class="ma-0 pa-0"
              placeholder="Serial Number, e.g. QF2720ED004F"
              @change="sernumChange"
              :disabled="isCloud"
              v-validate.initial="isCloud ? '': 'required|max:12|min:12'"
              data-vv-name="serialNumber"
              :error-messages="errors.collect('serialNumber')"
            >
            </v-text-field>
          </v-col>
       </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="companyName" 
              label="Company Name" class="ma-0 pa-0"
              placeholder="Company Name"
              v-validate.initial="'required'"
              data-vv-name="companyName"
              :error-messages="errors.collect('companyName')">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="customerId" 
              label="Customer Id" class="ma-0 pa-0"
              placeholder="Customer Id, e.g. QUM001"
              v-validate.initial="'required|max:6|min:6'"
              data-vv-name="customerId"
              :error-messages="errors.collect('customerId')">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="email" 
              label="Email" class="ma-0 pa-0"
              :placeholder="emailPlaceholder"
              v-validate.initial="'required|email|max:50'"
              data-vv-name="customerEmail"
              :error-messages="errors.collect('customerEmail')">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="firstName" 
              label="First Name" class="ma-0 pa-0"
              :placeholder="firstNamePlaceholder"
              v-validate.initial="'required'"
              data-vv-name="firstName"
              :error-messages="errors.collect('firstName')">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="lastName" 
              label="Last Name" class="ma-0 pa-0"
              :placeholder="lastNamePlaceholder"
              v-validate.initial="'required'"
              data-vv-name="lastName"
              :error-messages="errors.collect('lastName')">
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
        <v-card-actions>
          <div class="flex-grow-1"></div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <!-- this span allows me to get a tooltip on the button when it's disabled -->
                <span v-on="on">
                  <v-btn :disabled="errors.any()" class="ma-1" color="primary darken-1" @click="create">Create</v-btn>
                </span>
              </template>
              <span>
                This will create an Integrator Place with the provided Customer ID under the Qumulex Place on the <span style="font-weight: bold;">{{targetEnv}}</span> hierarchy. <br>
                It also creates a new record in the sysprep database companies table. <br>
                An Administrator role user with the provided email and name will be created at the new Integrator Place.<br>
                If this is a QXO system, the local Qx root app user will be made unique.
              </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <!-- this span allows me to get a tooltip on the button when it's disabled -->
                <span v-on="on">
                  <v-btn :disabled="errors.has('customerId')" class="ma-1" color="primary darken-1" @click="del">Delete</v-btn>
                </span>
              </template>
              <span>
                This is intended to undo the Create actions.  It does not delete the company from the sysprep <br>
                companies database because you may be deleting the integrator from a local gateway but not the cloud.<br>
                It this is a QXO system, the unique local Qx root app user remains on the system. 
              </span>
            </v-tooltip>
          <v-btn class="ma-1" color="primary darken-1" @click="close">Cancel</v-btn>
        </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import env from '../../server.config'

export default {
  name: "Integrator",
  props: {
    app: Object
  },
  data: () => ({
    companyName: '',
    customerId: '',
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    isCloud: true,
    customerType: 'Integrator',
    customerTypes: ['Distributor', 'Integrator'],
    serialNumber: '',
    lastSerialNumber: '',
    system: {},
  }),
  created() {
    console.log('integrator.vue created')
    this.initialize();
  },
  watch: {
    customerType() {
      console.log("watch customerType")
      if (this.customerType == 'Distributor') {
        this.isCloud = true;
      }
    }
  },
  computed: {
    isSerialNumberValid() {
      return !this.$validator.errors.has('serialNumber') 
    },
    emailPlaceholder() {
      return `${this.customerType} primary contact's email address`;
    },
    firstNamePlaceholder() {
      return `${this.customerType} primary contact's first name`;
    },
    lastNamePlaceholder() {
      return `${this.customerType} primary contact's last name`;
    },
    targetEnv() {
      if (this.isCloud) {
        return env.prodLevel
      } else {
        return this.serialNumber == '' ? 'the local gateway' : this.serialNumber;
      }
    },
  },

  methods: {
    initialize() {
    },

    create() {
      // create integrator, create user
      // if (isCloud) create root user, delete default user
      this.createStateMachine(0)
    },

    createStateMachine(state) {
      switch(state) {
        case 0:
          // create Integrator 
          this.postIntegrator(this.createStateMachine, state)
          break;
       case 1:
          // create user
          this.postUser(this.createStateMachine, state)
          break;
        case 2:
          // if !isCloud, create root user
          this.password = '';
          if (!this.isCloud) {
            this.postUser(this.createStateMachine, state)
          } else {
            this.advanceStateMachine(this.createStateMachine, state)
          }
          break;
        case 3:
          // Save root app user password in system secrets
          if (!this.isCloud) {
            this.postPassword(this.password, this.createStateMachine, state)
          } else {
            this.advanceStateMachine(this.createStateMachine, state)
          }
          break;
        case 4:
          // if !isCloud, delete default user
          if (!this.isCloud) {
            this.deleteUser("adminuser@qumulex.network", "", state)
          } else {
            this.advanceStateMachine(this.createStateMachine, state)
          }
          break;
       default:
          break;
      }
    },

    del() {
      let msg = "Are you sure you want to delete Integrator: " + this.customerId + "?\r\n"
      if (confirm(msg)) {
        // Delete user, delete integrator
        this.deleteStateMachine(10)
      }
    },

    deleteStateMachine(state) {
      switch(state) {
        case 10:
          // deleteUser 
          this.deleteUser(this.email, this.deleteStateMachine, state)
          break;
       case 11:
          // deleteIntegrator
          this.deleteIntegrator(this.customerId, this.close, state)
          break;
       default:
          break;
      }
    },

    sernumChange() {
      console.log("sernumchange")
      if (this.isSerialNumberValid && this.serialNumber !== this.lastSerialNumber) {
        this.lastSerialNumber = this.serialNumber // I can get duplicate events on @change for keydown and enter
        this.getSystem(this.serialNumber)
      }
    },

    close() {
      this.companyName = ''
      this.customerId = ''
      this.email = ''
      this.firstName = ''
      this.lastName = ''
    },

    advanceStateMachine(callback, state) {
      console.log("Integrator.vue advanceStateMachine: " + state)
      setTimeout(callback(state+1), 100)
    },

    getSystem(sernum) {
      let url = '/API/public/system/' + sernum
      console.log('getSystem(): url=' + url)
      this.app.restApi({
          method: 'get',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          this.system = response.data;
          console.log("system = " + this.system.id)
        })
        .catch(error => {
          console.log(error);
          if (error.response.status === 404) {
            alert("System with serial number " + this.serialNumber + " not found.")
          } else {
            let msg = "Error getting System for serial number " + this.serialNumber;
            msg += ". (" + error.response.status + ")"
            alert(msg)
          }
          this.system = {};
          this.serialNumber = ''
        });
    },
    
    postIntegrator(callback, state) {
      console.log("Integrator.vue postIntegrator: " + state)
      let url = `/API/public/${this.customerType.toLowerCase()}/new`
      url += '?'
      url += 'customerId=' + this.customerId
      url += '&name=' + encodeURIComponent(this.companyName)
      url += '&isCloud=' + this.isCloud
      if (!this.isCloud) {
        url += '&system_id=' + this.serialNumber
      }
      console.log('postIntegrator(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response)
          let msg = `Successfully created Integrator ${this.companyName} (${this.customerId}).\r\n`
          alert(msg)
          callback(state+1)
        })
        .catch( error => {
          if (error.response.status === 409) {
            alert("Integrator with customer ID " + this.customerId + " already exists.")
          } else {
            let msg = "Integrator could not be created with customer ID " + this.customerId;
            msg += ". (" + error.response.status + ")"
            alert(msg)
          }
        });
    },

    postUser(callback, state) {
      console.log("Integrator.vue postUser: " + state)
      let place = state === 1 ? this.customerId : "qx"
      let email = state === 1 ? this.email : this.serialNumber + "@qumulex.network"
      let firstName = state === 1 ? this.firstName : "default"
      let lastName = state === 1 ? this.lastName : "user"
      let verified = state === 1 ? false : true
      let url = `/API/public/${this.customerType.toLowerCase()}/user/new`
      url += '?'
      url += 'placeId=' + place
      url += '&email=' + encodeURIComponent(email)
      url += '&firstName=' + encodeURIComponent(firstName)
      url += '&lastName=' + encodeURIComponent(lastName)
      url += '&roleName=Administrator'
      url += '&verified=' + verified
      url += '&isCloud=' + this.isCloud
      if (!this.isCloud) {
        url += '&system_id=' + this.serialNumber
      }
      console.log('postUser(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response.data)
          this.password = response.data?.password
          alert("Successfully created user " + email + " at placeId " + place)
          callback(state+1)
        })
        .catch( error => {
          let msg = "User could not be created with email " + email + " at placeId " + place;
          msg += ". (" + error.response.status + ")"
          alert(msg)
        });
    },

    deleteIntegrator(id, callback, state) {
      console.log("Integrator.vue deleteIntegrator: " + state)
      let url = `/API/public/${this.customerType.toLowerCase()}/` + id
      url += '?'
      url += 'isCloud=' + this.isCloud
      if (!this.isCloud) {
        url += '&system_id=' + this.serialNumber
      }
      console.log('deleteIntegrator(): url=' + url)
      this.app.restApi({
          method: 'delete',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response)
          alert("Successfully deleted Integrator " + id )
          callback(state+1)
        })
        .catch( error => {
          if (error.response.status === 404) {
            alert("Integrator with customer ID " + id + " not found.")
          } else {
            let msg = "Integrator with customer ID " + id +  "could not be deleted";
            msg += ". (" + error.response.status + ")"
            alert(msg)
          }
        });
    },

    deleteUser(email, callback, state) {
      console.log("Integrator.vue deleteUser: " + state)
      let url = `/API/public/${this.customerType.toLowerCase()}/` + this.customerId + '/user'
      url += '?'
      url += 'email=' + encodeURIComponent(email)
      url += '&isCloud=' + this.isCloud
      if (!this.isCloud) {
        url += '&system_id=' + this.serialNumber
      }
      console.log('deleteUser(): url=' + url)
      this.app.restApi({
          method: 'delete',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response)
          let msg = `Successfully deleted User ${email}.\r\n`
          alert(msg)
          callback(state+1)
        })
        .catch( error => {
          if (error.response.status === 404) {
            alert("User with email " + email + " not found.")
          } else {
            let msg = "User with email " + email +  "could not be deleted";
            msg += ". (" + error.response.status + ")"
            alert(msg)
          }
        });
    },

    postPassword(password, callback, state) {
      console.log("Integrator.vue postPassword: " + state)
      let url = '/API/public/system/' + this.serialNumber + '/secrets'
      console.log('postPassword(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          },
          data: {
            prodLevel: env.prodLevel,
            qxAppOpsPwd: password
          }
        })
        .then(response => {
          console.log(response)
          let msg = `Successfully saved root app password ${password} to ${this.serialNumber}/secrets.`
          alert(msg)
          callback(state+1)
        })
        .catch( error => {
          if (error.response.status === 404) {
            alert("System with serial number " + this.serialNumber + " not found.")
          } else {
            let msg = "Unable to save root app password for " + this.serialNumber;
            msg += ". (" + error.response.status + ")"
            alert(msg)
          }
        })
        .finally( () => {
          this.password = ''
        });
    },

  }
}
</script>